<template>
  <v-progress-circular
    :size="25"
    :width="3"
    color="secondary"
    :class="extraClass"
    indeterminate
  ></v-progress-circular>
</template>
<script>
export default {
  props: {
    extraClass: {
      type: String,
      default: () => null,
    },
  },
};
</script>
